module.exports = __webpack_public_path__ + "static/media/icon-home.1219e173.svg";